import { Pipe, PipeTransform } from '@angular/core';
import { Config } from '../../models';

@Pipe({
  name: 'contentReplacePipe'
})
export class ContentReplacePipe implements PipeTransform {
  transform(value: string, args: Config): string {
    if (value !== undefined && args !== undefined) {
      Object.getOwnPropertyNames(args).forEach((key) => {
        value = value.replace('<<' + key + '>>', args[key]);
      });
      return value;
    } else {
      return '';
    }
  }
}
